<div class="modal fade" bsModal #modalRef="bs-modal" tabindex="-1" role="dialog" id="edit-group">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h4 id="dialog-child-name" class="modal-title">{{ group?.name }}</h4>
        <img src="assets/img/x.svg" class="icon-close" alt="Close" (click)="closeModal()" />
      </div>

      <div class="modal-body" [formGroup]="form">
        <div class="content-container" #contentContainer>
          <div class="form-container">
            <div class="section-header" (click)="toggleDetail()">
              <p class="section-title">Details</p>
              <img
                src="assets/img/svg/chevron-down-black.svg"
                class="icon-chevron"
                alt="Toggle"
                [class.open]="isDetailOpen" />
            </div>

            <div *ngIf="isDetailOpen" class="form-row">
              <div class="form-column" style="flex: 1">
                <p class="field-label">Name</p>
                <input
                  type="text"
                  class="form-control input-field"
                  formControlName="name"
                  [ngClass]="getValidationClass('name')" />
                <p *ngIf="form.get('name').errors?.groupNameExists" class="text-danger">This group already exists</p>
              </div>

              <div
                class="custom-select-wrapper form-column"
                style="flex: 1"
                dropdown
                [isDisabled]="form.get('type')?.disabled">
                <label class="field-label">What Type Of Flag Is It?</label>

                <div class="custom-select-trigger" dropdownToggle aria-haspopup="true">
                  <span class="selected-label">{{ form.get('type')?.value?.name || 'Select flag type' }}</span>
                  <img src="assets/img/svg/chevron-down-grey.svg" class="icon-chevron" />
                </div>

                <ul *dropdownMenu class="dropdown-menu select-list" role="menu">
                  <li *ngFor="let t of flagTypes" [hidden]="t.name === 'Legacy'">
                    <a
                      class="dropdown-item select-item"
                      [class.selected]="form.get('type')?.value?.id === t.id"
                      [class.disabled]="t.name === 'Legacy'"
                      (click)="t.name !== 'Legacy' && form.get('type')?.setValue(t)">
                      {{ t.name }}
                    </a>
                  </li>
                </ul>
              </div>

              <div
                class="custom-select-wrapper form-column"
                style="flex: 1"
                *ngIf="form.get('type')?.value?.name === 'Violation'"
                dropdown
                [autoClose]="true"
                [isDisabled]="form.get('subtype')?.disabled">
                <label class="field-label">And Subtype?</label>

                <div class="custom-select-trigger" dropdownToggle aria-haspopup="true">
                  <span class="selected-label">
                    {{ form.get('subtype')?.value?.name || 'Select subtype' }}
                  </span>
                  <img src="assets/img/svg/chevron-down-grey.svg" class="icon-chevron" />
                </div>

                <ul *dropdownMenu class="dropdown-menu select-list" role="menu">
                  <li *ngFor="let st of flagSubtypes">
                    <a
                      class="dropdown-item select-item"
                      [class.selected]="form.get('subtype')?.value?.id === st?.id"
                      (click)="form.get('subtype')?.setValue(st)">
                      {{ st?.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="form-column">
            <p class="field-label">Issue Description</p>
            <input type="text" class="form-control input-field" formControlName="description" />
          </div>

          <div class="flag-type-section" formGroupName="violation" *ngIf="form.get('type').value?.name == 'Violation'">
            <div class="form-column">
              <p class="field-label">Elevated Risk</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="elevatedRisk"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Why Does This Matter?</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="whyDoesThisMatter"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Actions Requested</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="actionRequested"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Documentation Requested</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="documentationRequested"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Documentation Pictures</p>
              <button class="btn btn-primary btn-rounded" (click)="openDocPictures()" [disabled]="readOnly">
                View/Add Pictures ({{ form.get('helpPictures')?.value?.length || 0 }})
              </button>
            </div>
            <div class="form-column">
              <p class="field-label">Deadline</p>
              <div *ngIf="false && !readOnly" class="btn-group" style="margin-bottom: 8px">
                <button
                  (click)="setDeadline('+30d')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 0 10px 1px 10px">
                  30 days
                </button>
                <button
                  (click)="setDeadline('+60d')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 0 10px 1px 10px">
                  60 days
                </button>
                <button
                  (click)="setDeadline('+90d')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 0 10px 1px 10px">
                  90 days
                </button>
              </div>
              <input
                formControlName="deadline"
                class="form-control input-field"
                bsDatepicker
                [bsConfig]="modalDateConfig" />
            </div>
            <div class="form-column">
              <p class="field-label">Internal notes</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="internalNotes"></app-markdown>
            </div>
            <div class="form-column">
              <p class="field-label">URL Title</p>
              <input type="text" formControlName="urlTitle" class="form-control input-field" />
            </div>

            <div class="form-column">
              <p class="field-label">URL</p>
              <input type="text" formControlName="url" class="form-control input-field" />
            </div>
          </div>

          <div
            class="flag-type-section"
            *ngIf="form.get('type').value?.name == 'Discrepancy'"
            formGroupName="discrepancy">
            <div class="form-column">
              <p class="field-label">Application Stated</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="stated"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Accurate Finding from Inspection</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="actual"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Result of the findings</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="resultOfTheFinding"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">Impact</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="impact"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label" style="margin-bottom: 0">Effective date</p>
              <div style="margin-bottom: 8px">
                <div *ngIf="!readOnly" class="btn-group btn-group-sm">
                  <button
                    (click)="setEffectiveDate('+30d')"
                    type="button"
                    class="btn btn-link"
                    style="padding: 0 10px 1px 10px">
                    30 days
                  </button>
                  <button
                    (click)="setEffectiveDate('+60d')"
                    type="button"
                    class="btn btn-link"
                    style="padding: 0 10px 1px 10px">
                    60 days
                  </button>
                  <button
                    (click)="setEffectiveDate('+90d')"
                    type="button"
                    class="btn btn-link"
                    style="padding: 0 10px 1px 10px">
                    90 days
                  </button>
                </div>

                <input
                  formControlName="effectiveDate"
                  class="form-control input-field"
                  bsDatepicker
                  [bsConfig]="modalDateConfig"
                  style="width: 20%" />
              </div>
            </div>

            <div class="form-column">
              <p class="field-label">Additional components for report</p>
              <app-markdown [toolbar]="[['ul']]" formControlName="commentsForReport"></app-markdown>
            </div>

            <div class="form-column">
              <p class="field-label">URL Title</p>
              <input type="text" formControlName="urlTitle" class="form-control input-field" />
            </div>

            <div class="form-column">
              <p class="field-label">URL</p>
              <input type="text" formControlName="url" class="form-control input-field" />
            </div>
          </div>
        </div>
        <div class="custom-scrollbar" #scrollbarTrack>
          <div class="custom-thumb" #scrollbarThumb></div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="footer-actions">
          <p class="apply-template" (click)="applyTemplate()">Apply template</p>
          <div class="action-buttons">
            <button class="btn btn-close" (click)="closeModal()">Cancel</button>
            <button class="btn btn-save" (click)="save()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #helpPicturesModal="bs-modal"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-child-name" class="modal-title pull-left">Documentation Pictures</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="cancelHelpPictures()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 25px">
        <form style="padding: 10px">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div *ngIf="!form.get('helpPictures')?.value?.length" style="margin-bottom: 20px">
                  No images attached
                </div>
                <div *ngIf="form.get('helpPictures')?.value?.length" style="margin-bottom: 20px">
                  <div
                    *ngFor="let p of form.get('helpPictures').controls; let i = index"
                    style="display: inline-block; max-width: 250px; margin: 10px">
                    <div [formGroup]="p">
                      <span
                        style="
                          display: inline-block;
                          width: 240px;
                          box-shadow: 0px 0px 7px #000;
                          margin: 5px;
                          position: relative;
                        ">
                        <img-ajax [src]="getSrc(p.value)"></img-ajax>
                        <span style="position: absolute; left: 5px; top: 5px"
                          ><button type="button" class="btn btn-danger btn-sm" (click)="removeHelpPicture(i)">
                            X
                          </button></span
                        >
                      </span>
                      <br />
                      <input type="text" formControlName="title" placeholder="Title" class="form-control" />
                      <app-markdown id="optionEditor" formControlName="caption" [options]="{ height: 150 }">
                      </app-markdown>
                    </div>
                  </div>
                </div>
                <input type="file" (change)="setUploadFile($event.target.files)" #fileHelpPicture />
                <button
                  type="button"
                  class="btn btn-primary aru"
                  (click)="uploadHelpPicture(fileHelpPicture)"
                  [disabled]="!fileHelpPicture.value">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </form>
        <button type="button" class="btn btn-primary aru" (click)="closeHelpPictures()">Confirm</button>
        <button type="button" class="btn btn-default aru" (click)="cancelHelpPictures()">Cancel</button>
      </div>
    </div>
  </div>
</div>
